import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-custom-cards',
    templateUrl: './block-custom-cards.component.html',
    styleUrls: ['./block-custom-cards.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})
export class BlockCustomCardsComponent extends BlockAbstractComponent implements OnInit {
    routerLinkUrl(url: string): string {
        return url.split('#')[0];
    }

    routerLinkFragment(url: string): string | undefined {
        if (url.includes('#')) {
            return url.split('#')[1];
        }
        return undefined;
    }

    getColumnCount(): number {
        return this.block.data.columnCountLargeBreakpoint ?? 4;
    }

    getCardColumnsClass() {
        switch (this.getColumnCount()) {
            case 3:
                return 'custom-cards--cols-xl-3';
            case 2:
                return 'custom-cards--cols-xl-2';
            case 1:
                return 'custom-cards--cols-xl-1';
            default:
                return 'custom-cards--cols-xl-4';
        }
    }
}
